module.exports = __webpack_public_path__ + "img/almoanda.06e9f8a3.png";